module.exports = __webpack_public_path__ + "static/media/Close.bd176c00.svg";